/*
 * @Author: your name
 * @Date: 2021-11-01 13:44:29
 * @LastEditTime: 2026-07-27 18:04:59
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @Description: In User Settings Edit
 * @FilePath: /isp_International/src/components/NavBar/index.tsx
 */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useRef, useState } from 'react';
import styled from './index.module.scss';

import cookies from 'react-cookies';
import { GetRequest, getUuid, getPvId } from '@/util';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { domainCookieUrl } from '@/enum/config';
import { isGuest } from '@/util/commonUtils';
import moment from 'moment';
import data from './setting.json';
import { dispatchLocation, dispatchSelectedAddress, dispatchSelectedPostalLocation } from '@/redux/action';
import { getAd, getChangeStation } from '@/api/newApi/header';
import {
  fetchHomepageOpenModules,
  getCachedHomepageOpenModules,
  normalizeHomepageOpenModulesValue,
  parseHotSearchWords,
  parseRecommendTextLinks,
} from '@/util/homepageConfig';
import { runWhenIdle } from '@/util/deferNonCriticalTask';
import Search from './search';
import { NATION_LOGO_MAP } from '@/constants/nationLogoMap';
import hotWordIcon from '@/assets/images/homeImg/hotWord.png';
import searchAiGuideIcon from '@/assets/images/aIcon.png';
import { useOpenDir } from '@/util/hooks/openPage';
import { usePermissions } from '@/util/hooks/checkPermissions';
import { isOrderCenterVisible } from '@/util/h5Permission';
import { message } from 'antd';
import {
  clearHomepageInitHandledForCurrentLogin,
  clearHomepageInitPending,
  clearHomepageStatusFailedInCurrentLogin,
} from '@/util/homepageInitState';
import { customClickReportSimple } from '@/dataPort';
import { openCustomerServiceChat } from '@/util/common';
import { setSearchRefreshReportId, usePvId } from '@/util/hooks/usePvId';
import { reportSearchAiEvent, SEARCH_AI_CLSTAG, SEARCH_AI_TRACK_EVENTS } from '@/util/searchAiTracking';
import { buildSearchAiLaunchUrl } from '@/util/searchAiLaunch';
import { reportSearchButtonClick } from '@/dataPort/verticalSearchReport';
import TopMetaBar from './TopMetaBar';
import HomeNavBar from './HomeNavBar';
import CategoryDrawer from '@/components/CategoryDrawer';
import AddArea from '@/components/Address/Drawer';
import AddressSelector from '@/components/Address/AddressSelector';
import { filterParams } from '@/util';
import { saveOrUpdateAddress } from '@/api/newApi/personalCenter/address';
import { fetchAddressDetailMerged, refreshHeaderAddress } from '@/util/headerAddressConfig';
import { addSearchHistory, isSkuId } from '@/api/newApi/search';
import {
  clearStoredSelectedAddress,
  buildSelectedAddressPayload,
  getStoredSelectedAddress,
  setStoredSelectedAddress,
} from '@/util/addressSelection';
import { buildSearchListHistoryLocation } from '@/pages/SearchList/utils/searchListUrl';
import { resetSessionBootstrap } from '@/util/sessionBootstrap';
import { getCustomerServiceHoursDisplay } from '@/util/customerServiceHours';
import {
  clearStoredPostalCodeLocation,
  formatPostalCodeLocationLabel,
  getStoredPostalCodeLocation,
  PostalCodeAddress,
  setStoredPostalCodeLocation,
} from '@/util/postalCodeAddress';

export interface IAppProps {
  location?: any;
}

interface SearchReportData {
  uuid: string;
  pvId: string;
  logId: string;
}

const defaultLanguageMap: Record<string, string> = {
  zh: '简体中文',
  en: 'English',
  vi: 'Tiếng Việt',
  hu: 'Magyar',
  th: 'ไทย',
  ms: 'Bahasa Melayu',
  'pt-BR': 'Português (Brasil)',
  zh_Hant: '繁体中文',
  id: 'Bahasa Indonesia',
  ru: 'Русский',
  de: 'Deutsch',
};

const WIDE_PAGE_PATHS = [
  '/page/list',
  '/activityPage',
  '/cart/carts',
  '/cart/batchAdd',
  '/cart/palletFill',
  '/order/goOrderInfo',
  '/order/detail',
  '/Approval',
  '/orderList',
  '/deleteOrderList',
  '/batchList',
  '/approvalList',
  '/addressList',
  '/authorityAddress',
  '/materialManage',
  '/accountSettings',
  '/bindingEmail',
  '/processList',
  '/editProcess',
  '/createProcess',
  '/taskCenter',
  '/remittance',
  '/settleConfig',
  '/afterSalesPolicy',
  '/afterSale/apply',
  '/afterSale/detail',
  '/searchAi',
  '/rede/searchAi',
];

// 失效页从商详跳入，顶栏继续用商详宽屏。/skuUnavailable 不以 /sku/ 开头，不会被下面的前缀命中。
const isWidePagePath = (pathname: string) =>
  WIDE_PAGE_PATHS.includes(pathname) || pathname.startsWith('/sku/') || pathname === '/skuUnavailable';

const NavBar: React.FC<IAppProps> = (props: IAppProps) => {
  const { func, style } = data;
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const routerLocation = useLocation();
  const [ad, setAdData] = useState<any>([]);
  const [showShopType, setShowShopType] = useState<boolean>(false); //商品类型
  const [isLocalPro] = useState<boolean>(cookies.load('stationType') == '0'); // 当前站点是否本土
  const [quickButtons, setQuickButtons] = useState<
    Array<{
      name: string;
      jumpUrl: string;
      openType: number;
      jumpType: 'url' | 'category' | 'keyword';
      keyword: string;
      categoryId: string;
    }>
  >([]); //语言列表
  const [hotSearchWords, setHotSearchWords] = useState<Array<{ id: string; sort: number; text: string }>>([]);
  const dispatch = useDispatch();
  const url: any = GetRequest();
  const openDir = useOpenDir();
  const initialStoredAddress = getStoredSelectedAddress();
  const initialStoredPostalLocation = getStoredPostalCodeLocation();
  const [showDrawerNew, setShowDrawerNew] = useState(false);
  const [headerAddressSelectorVisible, setHeaderAddressSelectorVisible] = useState(false);
  const [headerAddressAddVisible, setHeaderAddressAddVisible] = useState(false);
  const [headerConsigneeList, setHeaderConsigneeList] = useState<any[]>([]);
  const [selectedHeaderAddress, setSelectedHeaderAddress] = useState<any>(
    buildSelectedAddressPayload(initialStoredAddress) || initialStoredAddress || null,
  );
  const [selectedHeaderPostalLocation, setSelectedHeaderPostalLocation] = useState<PostalCodeAddress | null>(
    initialStoredPostalLocation,
  );
  const [searchAiKeyword, setSearchAiKeyword] = useState('');
  const searchAiClickAtRef = useRef(0);
  const quickButtonsListRef = useRef<HTMLDivElement | null>(null);
  const [showQuickScrollLeft, setShowQuickScrollLeft] = useState(false);
  const [showQuickScrollRight, setShowQuickScrollRight] = useState(false);

  const { checkPermission, loading, permissions } = usePermissions();
  // AI 行家导航入口由后端权限点控制，避免无权限账号看到新开页入口。
  const canShowSearchAiGuide = !isGuest() && Boolean(checkPermission('O_aiBuyButton'));
  const showOrderCenter = isOrderCenterVisible(permissions);
  // 使用统一的 pvid 管理 hook
  const { updatePvId } = usePvId({ autoInit: false });

  const uuid = getUuid();
  // 语言切换
  const changeLanguage = async (type: any) => {
    if (i18n.language == type) return;
    try {
      window.localStorage.setItem('_language', type);
      // 切中英文，清空搜索关键词，产品定的
      window.localStorage.setItem('iv', '');
      window.location.reload();
    } catch (error) {
      console.log(error, '0000');
    }
  };

  /**
   * 保存cookie
   */
  const saveCookie = (key: string, value: string) => {
    cookies.save(key, value, {
      domain: domainCookieUrl,
      path: '/',
      // sameSite:'none',
      expires: moment()
        .add(1, 'months')
        .toDate(),
    });
  };

  /**
   * 切换站点 type 0 本土 跨境
   */
  const changeStationOper = async (type: string) => {
    const resData = await getChangeStation({
      stationType: type,
    });
    saveCookie('stationType', type);
    //切换站点 清空历史记录
    window.localStorage.setItem('iv', '');
    // 邮编定位依赖当前站点国家，切站后旧结果不可继续作为全局配送位置。
    clearStoredPostalCodeLocation();
    window?.open('/', '_self');
  };

  // 获取广告数据
  const fetchData = async () => {
    const adData: any = (await getAd()) as any;
    setAdData(adData.value);
  };
  const reduxUser = useSelector((state: any) => state?.User?.data?.[0]);
  const selectedAddressFromRedux = useSelector((state: any) => state?.User?.selectedAddress);
  const selectedPostalLocationFromRedux = useSelector((state: any) => state?.User?.selectedPostalLocation);
  const cartCount = useSelector((state: any) => state?.User?.carNum);
  const searchSubmitting = useSelector((state: any) => state?.SearchList?.searchSubmitting ?? false);
  //是否是IE白名单
  const clientOpenWindow: any = useSelector((state: any) => {
    return state?.User?.data[0]?.clientOpenWindow;
  });
  // 获取用户类型
  const userType: any = useSelector((state: any) => {
    return state?.User?.data[0]?.userType;
  });

  // 获取用户类型
  const logoIcon: any = useSelector((state: any) => {
    return state?.User?.data[0]?.logo;
  });

  // 用户信息接口是否已返回（data 拉到后才有值）。
  // logo 三态依赖它：未返回时先留空占位，避免「兜底图→真 logo」闪烁；
  // 已返回但无 logo（或访客）才用京东兜底图。
  const isUserInfoLoaded = useSelector((state: any) => {
    return (state?.User?.data?.length || 0) > 0;
  });

  //用户可访问站点列表
  const stationsList = useSelector((state: any) => {
    return state?.User?.data[0]?.stations || [];
  });

  // 修复游客态语言下拉只显示当前语言的问题：客户登记等公共页没有 user.language，
  // 这里回退到前端已支持的完整语言表，保证右上角可切全部语言。
  const languageList = reduxUser?.language || defaultLanguageMap;
  const countryNameMap = reduxUser?.countryNameMap;

  // 用户信息由 router 鉴权写入 Redux；NavBar 只同步站点/语言校验，不再 fallback 请求 /jdig/account/me
  useEffect(() => {
    if (!reduxUser || reduxUser.userType === undefined || reduxUser.userType === null) {
      return;
    }

    const stationList = reduxUser.stations || [];
    const stationType = cookies.load('stationType');
    const isNeedLoadLanguage = reduxUser.language && !reduxUser.language[i18n.language];

    if (!stationType || stationList.indexOf(+stationType) === -1) {
      if (stationList.length > 0) {
        saveCookie('stationType', stationList[0]);
        window.localStorage.setItem('iv', '');
        window?.open('/', '_self');
      }
      return;
    }

    if (isNeedLoadLanguage) {
      window.localStorage.setItem('_language', 'zh');
      window?.open(window?.location?.href, '_self');
    }
  }, [reduxUser, i18n.language]);

  const applyHomePageNavConfig = (result: ReturnType<typeof getCachedHomepageOpenModules>) => {
    if (!result?.success) {
      return;
    }
    const navConfig = normalizeHomepageOpenModulesValue(result.value);
    setQuickButtons(parseRecommendTextLinks(navConfig));
    setHotSearchWords(parseHotSearchWords(navConfig));
  };

  const initQuickButtons = async () => {
    const cached = getCachedHomepageOpenModules();
    if (cached?.success) {
      applyHomePageNavConfig(cached);
      return;
    }

    // 热搜词 / 推荐文字链走 openModules 按需接口，不再依赖全量 /jdig/settings/v2/homepage
    const result = await fetchHomepageOpenModules();
    applyHomePageNavConfig(result);
  };

  const handleQuickButtonsScroll = (direction: 'left' | 'right') => {
    const container = quickButtonsListRef.current;
    if (!container) {
      return;
    }

    const scrollOffset = Math.max(container.clientWidth * 0.6, 240);
    const nextOffset = direction === 'left' ? -scrollOffset : scrollOffset;
    container.scrollBy({
      left: nextOffset,
      behavior: 'smooth',
    });
  };

  const syncQuickButtonsScrollState = () => {
    const container = quickButtonsListRef.current;
    if (!container) {
      setShowQuickScrollLeft(false);
      setShowQuickScrollRight(false);
      return;
    }

    const maxScrollLeft = Math.max(container.scrollWidth - container.clientWidth, 0);
    const currentScrollLeft = Math.max(container.scrollLeft, 0);
    const isAtStart = currentScrollLeft <= 1;
    const isAtEnd = currentScrollLeft >= maxScrollLeft - 1;
    const hasOverflow = maxScrollLeft > 1;

    setShowQuickScrollLeft(hasOverflow && !isAtStart);
    setShowQuickScrollRight(hasOverflow && !isAtEnd);
  };
  useEffect(() => {
    // 热搜 / 推荐链非首屏 LCP，在 getUserConfig 之后再错峰拉 openModules
    const cancelIdle = runWhenIdle(
      () => {
        void initQuickButtons();
      },
      { delayMs: 300, timeoutMs: 4000 },
    );

    return cancelIdle;
  }, [routerLocation.pathname]);
  //退出登录
  const logoutFn = () => {
    fetch('//sso.jdindustry.com/exit', {
      method: 'GET',
      credentials: 'include',
    }).finally(() => {
      clearHomepageInitHandledForCurrentLogin();
      clearHomepageInitPending();
      clearHomepageStatusFailedInCurrentLogin();
      resetSessionBootstrap();
      clearStoredSelectedAddress();
      clearStoredPostalCodeLocation();
      window.location.href = WISP_LOGIN_URL;
    });
  };
  // 「全部分类」改为纯点击展开/收起，去掉 hover 触发，避免鼠标划过误触
  const showDrawer = (show: boolean) => {
    setShowDrawerNew(show);
  };
  const handleRegisterClick = () => {
    history.push('/register/guide');
  };
  const handleLoginClick = () => {
    // 各国家游客池复用构建环境登录地址，避免测试流量误跳线上认证入口。
    window.location.href = WISP_LOGIN_URL;
  };
  useEffect(() => {
    const container = quickButtonsListRef.current;
    if (!container) {
      return;
    }

    syncQuickButtonsScrollState();
    container.addEventListener('scroll', syncQuickButtonsScrollState);
    window.addEventListener('resize', syncQuickButtonsScrollState);

    return () => {
      container.removeEventListener('scroll', syncQuickButtonsScrollState);
      window.removeEventListener('resize', syncQuickButtonsScrollState);
    };
  }, [quickButtons]);
  const toBatchCart = () => {
    history.push({
      pathname: '/cart/batchAdd',
    });
  };

  const userTypeText: Record<number, string> = {
    4: '管理员',
    5: '采购员',
    6: '审批员',
  };

  const reportCreateVerticalSearchAllClick = () => {
    const { pvId, logId } = updatePvId('new_search');
    const unifiedId = pvId || logId;
    // 写入统一 refresh id，给下一页 result_counts / cable_skuexposure 强制对齐
    setSearchRefreshReportId(unifiedId);
    reportSearchButtonClick({
      keyword: '搜索全部商品',
      input_word: '',
      pin: reduxUser?.pin,
      uuid,
      pvid: pvId,
      logid: logId,
      userType: reduxUser?.userType === 5 ? 1 : 2,
      source: '11', // 1 搜索框 2 类目 11 搜索全部商品 -1 其他
      timestamp: Date.now(), // 点击事件时间戳
      ext: '',
      contractid: reduxUser?.contractNum,
    });
  };

  const getSearchReportData = (): SearchReportData => {
    const { pvId, logId } = updatePvId('new_search');
    const unifiedId = pvId || logId;
    // 写入统一 refresh id，给下一页 result_counts / cable_skuexposure 强制对齐
    setSearchRefreshReportId(unifiedId);
    return {
      uuid,
      pvId,
      logId,
    };
  };
  const handleQuickButtonClick = async (button: {
    name: string;
    jumpUrl: string;
    openType: number;
    jumpType: 'url' | 'category' | 'keyword';
    keyword: string;
    categoryId: string;
  }) => {
    if (searchSubmitting) {
      return;
    }
    if (button.name === '搜索全部商品') {
      reportCreateVerticalSearchAllClick();
    }

    if (button.jumpType === 'url' && button.jumpUrl) {
      openDir(button);
      return;
    }

    if (button.jumpType === 'category' && button.categoryId) {
      // 搜索历史属于非关键埋点，异步写入即可，避免阻塞进入搜列页。
      void addSearchHistory(button.name);
      const result: any = await isSkuId(button.name);
      if (result?.success && result?.value) {
        window.location.href = `${window.location.origin}/sku/${result.value}`;
        return;
      }
      history.push(
        buildSearchListHistoryLocation(
          {
            cat: button.categoryId,
            pageNo: 1,
            sort: 0,
          },
          {
            cataIdList: button.categoryId,
            cat: button.categoryId,
          },
          {
            query: button.name || '',
            searchTriggerTs: Date.now(),
          },
        ),
      );
      return;
    }

    if (button.jumpType === 'keyword' && button.keyword) {
      // 搜索历史属于非关键埋点，异步写入即可，避免阻塞进入搜列页。
      void addSearchHistory(button.keyword);
      const result: any = await isSkuId(button.keyword);
      if (result?.success && result?.value) {
        window.location.href = `${window.location.origin}/sku/${result.value}`;
        return;
      }
      history.push(
        buildSearchListHistoryLocation(
          {
            key: button.keyword,
            pageNo: 1,
            sort: 0,
          },
          {},
          {
            query: button.keyword,
            searchTriggerTs: Date.now(),
          },
        ),
      );
    }
  };
  const handleHotSearchWordClick = async (word: string) => {
    if (searchSubmitting) {
      return;
    }
    const keyword = `${word || ''}`.trim();
    if (!keyword) return;

    getSearchReportData();
    customClickReportSimple('HomePage_HotSearchWordClk', {
      keyword,
      timestamp: Date.now(),
    });
    // 热词点击优先保障跳转速度，历史记录异步落库。
    void addSearchHistory(keyword);
    const result: any = await isSkuId(keyword);
    if (result?.success && result?.value) {
      window.location.href = `${window.location.origin}/sku/${result.value}`;
      return;
    }
    history.push(
      buildSearchListHistoryLocation(
        {
          key: keyword,
          pageNo: 1,
          sort: 0,
        },
        {},
        {
          query: keyword,
          searchTriggerTs: Date.now(),
        },
      ),
    );
  };
  const currentStationType = cookies.load('stationType');
  const isHomePage = routerLocation.pathname === '/';
  const isWidePage = isWidePagePath(routerLocation.pathname);
  const topSiteName = countryNameMap?.[i18n.language || 'zh'] || '';
  // 邮编定位与地址簿地址共用同一套页头拼接规则，避免两种选择方式展示不一致。
  const formattedTopAddressText = formatPostalCodeLocationLabel(selectedHeaderAddress);
  const formattedPostalLocationText = formatPostalCodeLocationLabel(selectedHeaderPostalLocation);
  const topAddressText = formattedPostalLocationText || formattedTopAddressText || topSiteName;
  const topLanguageName = languageList?.[i18n.language] || defaultLanguageMap[i18n.language] || TLT('简体中文');
  const customerServiceHours = getCustomerServiceHoursDisplay(
    reduxUser?.countryCode || selectedHeaderAddress?.countryCode || selectedHeaderAddress?.country,
    i18n.language,
  );

  const clearSelectedPostalLocation = () => {
    clearStoredPostalCodeLocation();
    setSelectedHeaderPostalLocation(null);
    dispatch(dispatchSelectedPostalLocation({}));
  };

  const applySelectedAddress = (
    address: any,
    source: 'manual' | 'default' = 'manual',
    activateAddress = true,
  ) => {
    const selectedAddress = buildSelectedAddressPayload(address, source);
    if (!selectedAddress) return;
    if (activateAddress) {
      // 用户主动选收货地址时退出邮编定位模式，顶部与实际选中动作保持一致。
      clearSelectedPostalLocation();
    }
    setSelectedHeaderAddress(selectedAddress);
    setStoredSelectedAddress(selectedAddress);
    dispatch(dispatchSelectedAddress(selectedAddress));
  };

  const applySelectedPostalLocation = (location: PostalCodeAddress) => {
    const nextLocation = {
      ...location,
      countryCode: location.countryCode || reduxUser?.countryCode || reduxUser?.country,
      countryName: location.countryName || topSiteName,
    };
    setSelectedHeaderPostalLocation(nextLocation);
    setStoredPostalCodeLocation(nextLocation);
    dispatch(dispatchSelectedPostalLocation(nextLocation));
  };

  useEffect(() => {
    const selectedAddress = buildSelectedAddressPayload(selectedAddressFromRedux);
    if (selectedAddress) {
      setSelectedHeaderAddress(selectedAddress);
    }
  }, [selectedAddressFromRedux]);

  useEffect(() => {
    if (formatPostalCodeLocationLabel(selectedPostalLocationFromRedux)) {
      setSelectedHeaderPostalLocation(selectedPostalLocationFromRedux);
    } else if (selectedPostalLocationFromRedux && !Object.keys(selectedPostalLocationFromRedux).length) {
      setSelectedHeaderPostalLocation(null);
    }
  }, [selectedPostalLocationFromRedux]);

  const refreshHeaderAddressList = async (preferredAddressId?: number | string, submittedAddress?: any) => {
    const result = await refreshHeaderAddress({
      preferredAddressId,
      submittedAddress,
      forceRefresh: Boolean(preferredAddressId || submittedAddress),
    });

    setHeaderConsigneeList(result.list);

    if (result.selected) {
      applySelectedAddress(
        result.selected,
        result.selectedSource,
        Boolean(preferredAddressId || submittedAddress),
      );
    } else {
      setSelectedHeaderAddress(null);
      dispatch(dispatchSelectedAddress({}));
    }

    return result.list;
  };

  const handleHeaderAddressClick = async () => {
    if (isGuest()) return;
    if (!headerConsigneeList.length) {
      await refreshHeaderAddressList();
    }
    // 即使没有已保存地址也打开选择抽屉，用户仍需从这里使用邮编定位或进入新增地址。
    setHeaderAddressSelectorVisible(true);
  };

  const onSaveHeaderAddress = async (address: any) => {
    const selectedPins = address.userPins || [];
    const authScope =
      address.allocType ||
      (reduxUser?.userType === 5 &&
      !address.addressId &&
      !address.addressManagerId &&
      !address.contractId &&
      !address.id
        ? 1
        : address.allocType);

    let countryCode = address.countryCode || '';
    if (!countryCode && address?.country) {
      countryCode = address.country;
    }

    const params: any = {
      receiveName: address.receiveName,
      receivePhone: address.receivePhone,
      country: countryCode,
      countryId: address.countryId || address.countryArea,
      provinceId: address.provinceId,
      cityId: address.cityId,
      countyId: address.countyId,
      detailAddress: address.detailAddress,
      postalCode: address.postalCode || '',
      defaultStatus:
        reduxUser?.userType === 5 ? (address.defaultStatus === true || address.defaultStatus === 1 ? 1 : 0) : 0,
      authScope: authScope || 1,
    };

    if (authScope === 3 && selectedPins.length > 0) {
      params.selectedPins = selectedPins;
    }

    if (address.contractId || address.id || address.addressId || address.addressManagerId) {
      params.addressId = address.contractId || address.id || address.addressId || address.addressManagerId;
    }

    const res: any = await saveOrUpdateAddress(filterParams(params) as any);
    if (res.success) {
      const savedAddress = res.value || res.data || {};
      const savedId = savedAddress.addressManagerId || savedAddress.addressId || savedAddress.id;
      // 刷新方法会基于完整列表定位新地址并合并详情；避免再用仅含 ID 的详情结果覆盖国家/城市名称。
      await refreshHeaderAddressList(savedId, params);
      setHeaderAddressAddVisible(false);
      message.success(params.addressId ? TLT('地址修改成功') : TLT('地址添加成功'));
    } else {
      message.error(res.msg || TLT('保存失败，请重试'));
    }
  };

  const handleSearchAiGuideClick = () => {
    // 连续双击只打开一次；后续有意再次搜索仍创建独立会话。
    if (Date.now() - searchAiClickAtRef.current < 800) return;
    searchAiClickAtRef.current = Date.now();
    reportSearchAiEvent(SEARCH_AI_TRACK_EVENTS.entryClick, undefined, SEARCH_AI_CLSTAG.entry);
    // q/requestId 是主应用与导购承载页约定的一次性检索指令，不能只预填输入框。
    const targetUrl = buildSearchAiLaunchUrl(window.location.origin, searchAiKeyword, getPvId());
    window.open(targetUrl, '_blank', 'noopener,noreferrer');
  };

  const searchNode = (
    <div className={styled.con_search}>
      <div className={styled.searchEntryRow}>
        <div className={styled.searchEntryInput}>
          <Search
            clientOpenWindow={clientOpenWindow}
            getSearchReportData={getSearchReportData}
            {...func}
            {...style}
            {...props}
            onInputValueChange={setSearchAiKeyword}
          ></Search>
        </div>
        {canShowSearchAiGuide && (
          <button type="button" className={styled.searchAiGuideButton} clstag={SEARCH_AI_CLSTAG.entry} onClick={handleSearchAiGuideClick}>
            <img className={styled.searchAiGuideIcon} src={searchAiGuideIcon} alt="" aria-hidden="true" />
            <span className={styled.searchAiGuideText}>{TLT('行家导航')}</span>
          </button>
        )}
      </div>
      <div className={styled.hotSearchWords}>
        {hotSearchWords.length > 0 && (
          <div className={styled.hotSearchLabel}>
            <img className={styled.hotSearchIcon} src={hotWordIcon} alt="" />
            <span>{TLT('热词搜索')}</span>
          </div>
        )}
        {hotSearchWords.length > 0 &&
          hotSearchWords.map(item => (
            <button
              key={item.id}
              type="button"
              className={styled.hotSearchWord}
              onClick={() => {
                handleHotSearchWordClick(item.text);
              }}
              disabled={searchSubmitting}
              title={item.text}
            >
              {item.text}
            </button>
          ))}
      </div>
    </div>
  );
  return (
    <>
      <TopMetaBar
        isHomePage={isHomePage}
        isWidePage={isWidePage}
        siteName={topSiteName}
        selectedAddressText={topAddressText}
        languageName={topLanguageName}
        languageMap={languageList || {}}
        nationLogoMap={NATION_LOGO_MAP}
        currentLanguage={i18n.language}
        userTypeName={!isGuest() && userTypeText[reduxUser?.userType] ? TLT(userTypeText[reduxUser.userType]) : ''}
        nickName={!isGuest() ? reduxUser?.nickName : ''}
        isGuestUser={isGuest()}
        showCustomerService={checkPermission('S_showCustomerService')}
        showLogout={checkPermission('S_displayLogout')}
        onCustomerServiceClick={openCustomerServiceChat}
        customerServiceHours={customerServiceHours}
        onChangeLanguage={changeLanguage}
        onWorkspaceClick={() => {
          history.push({ pathname: '/accountSettings' });
          customClickReportSimple('Workspace');
        }}
        onBatchCartClick={toBatchCart}
        onLogoutClick={logoutFn}
        workspaceText={TLT('我的工作台')}
        batchAddCartText={TLT('批量加购')}
        logoutText={TLT('退出登录')}
        customerServiceText={TLT('客户服务')}
        onAddressClick={handleHeaderAddressClick}
      />
      <HomeNavBar
        isHomePage={isHomePage}
        isWidePage={isWidePage}
        loading={loading}
        logoIcon={logoIcon}
        logoResolved={isGuest() || isUserInfoLoaded}
        isGuestUser={isGuest()}
        cartCount={cartCount}
        searchNode={searchNode}
        showOrderCenter={showOrderCenter}
        onLogoClick={() => {
          window.location.href = '/';
        }}
        onOrderCenterClick={() => {
          history.push({
            pathname: userType === 6 ? '/approvalList' : '/orderList',
          });
          customClickReportSimple('OrderManagement');
        }}
        onBatchDownloadClick={toBatchCart}
        onRegisterClick={handleRegisterClick}
        onLoginClick={handleLoginClick}
        onCartClick={() => {
          customClickReportSimple('Cart');
          history.push({
            pathname: '/cart/carts',
          });
          customClickReportSimple('Cart');
        }}
        orderCenterText={TLT('订单中心')}
        batchDownloadText={TLT('批量加购')}
        cartText={TLT('购物车')}
        registerText={TLT('注册')}
        loginText={TLT('登录')}
      />

      <div
        className={`${styled.container} ${isHomePage ? styled.homeContainer : ''} ${
          isWidePage ? styled.wideContainer : ''
        }`}
      >
        <div className={styled.containerInfo}>
          <div className={styled.quickBtns}>
            <div className={styled.categoryWrap}>
              <button
                type="button"
                className={`${styled.containerInfoItem} ${styled.categoryTrigger} ${
                  showDrawerNew ? styled.categoryTriggerActive : ''
                }`}
                onClick={() => {
                  showDrawer(!showDrawerNew);
                }}
                data-track={JSON.stringify({
                  eventId: 'CategoryButton',
                })}
              >
                <span>{TLT(`商品分类`)}</span>
                <i
                  className={`iconFont icon-expand ${styled.categoryArrow} ${
                    showDrawerNew ? styled.categoryArrowActive : ''
                  }`}
                  aria-hidden="true"
                />
              </button>
            </div>
            <div className={styled.quickButtonsScroller}>
              <div className={styled.quickButtonsViewport} ref={quickButtonsListRef}>
                {quickButtons.map((button, index) => (
                  <button
                    key={`${button.name}-${index}`}
                    type="button"
                    className={styled.containerInfoItem}
                    onClick={() => {
                      handleQuickButtonClick(button);
                    }}
                  >
                    {button.name}
                  </button>
                ))}
              </div>
              <div className={styled.quickScrollActions}>
                <button
                  type="button"
                  className={`${styled.quickScrollButton} ${styled.quickScrollButtonLeft} ${
                    !showQuickScrollLeft ? styled.quickScrollButtonDisabled : ''
                  }`}
                  onClick={() => {
                    handleQuickButtonsScroll('left');
                  }}
                  aria-label={TLT('向右滚动快捷入口')}
                  aria-disabled={!showQuickScrollLeft}
                >
                  <span
                    className={`${styled.quickScrollChevron} ${styled.quickScrollChevronLeft}`}
                    aria-hidden="true"
                  />
                </button>
                <button
                  type="button"
                  className={`${styled.quickScrollButton} ${styled.quickScrollButtonRight} ${
                    !showQuickScrollRight ? styled.quickScrollButtonDisabled : ''
                  }`}
                  onClick={() => {
                    handleQuickButtonsScroll('right');
                  }}
                  aria-label={TLT('向左滚动快捷入口')}
                  aria-disabled={!showQuickScrollRight}
                >
                  <span
                    className={`${styled.quickScrollChevron} ${styled.quickScrollChevronRight}`}
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <CategoryDrawer visible={showDrawerNew} onClose={() => showDrawer(false)} />
      </div>

      <AddressSelector
        showDrawer={headerAddressSelectorVisible}
        consignee={selectedHeaderAddress}
        consigneeList={headerConsigneeList}
        setConsigneeList={setHeaderConsigneeList}
        showAddAddressButton
        showPostalCodeLookup
        initialPostalCode={
          selectedHeaderPostalLocation?.queryPostalCode || selectedHeaderPostalLocation?.postalCode || ''
        }
        onPostalLocationSelect={applySelectedPostalLocation}
        onAddAddressClick={() => {
          setHeaderAddressSelectorVisible(false);
          setHeaderAddressAddVisible(true);
        }}
        setConsignee={async (item: any) => {
          setSelectedHeaderAddress({
            id: item.id || item.addressId,
            addressId: item.id || item.addressId,
            provinceName: '',
            countryName: '',
          });

          let selectedItem = item;
          const itemId = item.id || item.addressId;
          if (itemId) {
            selectedItem = await fetchAddressDetailMerged(item, true);
          }
          applySelectedAddress(selectedItem);
        }}
        closeDrawer={() => {
          setHeaderAddressSelectorVisible(false);
        }}
      />

      <AddArea
        address={{}}
        visible={headerAddressAddVisible}
        onOk={onSaveHeaderAddress}
        onCancel={() => {
          setHeaderAddressAddVisible(false);
        }}
      />
    </>
  );
};
export default NavBar;
